var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncementImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.719,
    height: 86.701,
    viewBox: "0 0 94.719 86.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Announcement_2358511",
    transform: "translate(0 23.004) rotate(-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41960",
    "data-name": "Path 41960",
    d: "M8.635,36.669h4.178V59.051a7.35,7.35,0,0,0,7.1,7.557,7.35,7.35,0,0,0,7.113-7.557V42.3C46.65,44.348,62.009,55.039,64.339,55.039a3.522,3.522,0,0,0,3.446-3.585V40.834A12.934,12.934,0,0,0,78.669,27.47,12.911,12.911,0,0,0,67.785,14.118V3.585A3.522,3.522,0,0,0,64.342,0C61.729,0,46.127,12.139,24.133,12.9a.745.745,0,0,0-.085.02,13.23,13.23,0,0,0-10.37,5.337H8.635A8.942,8.942,0,0,0,0,27.465a8.942,8.942,0,0,0,8.631,9.2ZM19.909,63.328a4.071,4.071,0,0,1-3.819-4.277V39.12a12.914,12.914,0,0,0,7.661,2.869V59.051a4.079,4.079,0,0,1-3.839,4.277ZM75.4,27.479A9.731,9.731,0,0,1,67.788,37.54V17.409A9.736,9.736,0,0,1,75.4,27.479ZM25.829,16.1A86.8,86.8,0,0,0,64.342,3.277c.037,0,.167.074.167.308V51.458c0,.232-.136.308-.17.308l-.042-.014a98.578,98.578,0,0,0-38.47-12.883V16.1Zm-3.277.243V38.578a11.025,11.025,0,0,1-8.668-11.113A11.025,11.025,0,0,1,22.55,16.349Zm-13.917,5.2H11.8a15.359,15.359,0,0,0,0,11.854H8.635a5.668,5.668,0,0,1-5.354-5.937,5.688,5.688,0,0,1,5.354-5.917Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementImg);
export default __webpack_public_path__ + "static/media/Announcement-img.883c6bec606358b3d32019818bfb02a8.svg";
export { ForwardRef as ReactComponent };